module.exports = __webpack_public_path__ + "static/media/trevor.bf1b16f6.jpg";